var map = {
	"./amazon.png": 2125,
	"./bharatPe.png": 6404,
	"./bhim.png": 229,
	"./freecharge.png": 119,
	"./gPay1.png": 8421,
	"./gPay2.png": 5998,
	"./india.png": 9716,
	"./indiaF.png": 2440,
	"./indiaM.png": 6923,
	"./mobiKwik1.png": 6419,
	"./mobiKwik2.png": 9560,
	"./paytm.png": 8654,
	"./phonePe.png": 1608,
	"./upi.png": 5429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1206;